import { Button } from '@mui/material';
import { MouseEventHandler } from 'react';

import './Button.sass';

interface Props {
  children: React.ReactNode;
  variant: 'blue' | 'orange' | 'outlined' | 'gray' | 'orange-transparent';
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const CustomButton: React.FC<Props> = ({
  children,
  variant,
  className,
  onClick,
}) => {
  return (
    <Button
      variant="contained"
      className={`button ${className} ${variant} `}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
